namespace Matrix.Workflow {
    export interface ClientFunctionInvokeResponse extends Serenity.ServiceResponse {
    }
}
